import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Rhybudd, MathRhybudd } from '../../modelau/rhybudd';

@Injectable({ providedIn: 'root' })
export class RhybuddService {
    private testun = new Subject<Rhybudd>();
    private cadwArOlNewidRoute = false;

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.cadwArOlNewidRoute) {
                    this.cadwArOlNewidRoute = false;
                } else {
                    this.clirio();
                }
            }
        });
    }

    onAlert(rhybuddId?: string): Observable<Rhybudd> {
        return this.testun.asObservable().pipe(filter(x => x && x.rhybuddId === rhybuddId));
    }

    llwyddiant(neges: string, cadwArOlNewidRoute = false, rhybuddId?: string) {
        this.alert(new Rhybudd({ neges, math: MathRhybudd.Llwyddiant, cadwArOlNewidRoute, rhybuddId }));
    }

    gwall(neges: string, cadwArOlNewidRoute = false, rhybuddId?: string) {
        this.alert(new Rhybudd({ neges, math: MathRhybudd.Gwall, cadwArOlNewidRoute, rhybuddId }));
    }

    gwybodaeth(neges: string, cadwArOlNewidRoute = false, rhybuddId?: string) {
        this.alert(new Rhybudd({ neges, math: MathRhybudd.Gwybodaeth, cadwArOlNewidRoute, rhybuddId }));
    }

    rhybudd(neges: string, cadwArOlNewidRoute = false, rhybuddId?: string) {
        this.alert(new Rhybudd({ neges, math: MathRhybudd.Rhybudd, cadwArOlNewidRoute, rhybuddId }));
    }

    alert(rhybudd: Rhybudd) {
        this.cadwArOlNewidRoute = rhybudd.cadwArOlNewidRoute;
        // ddim yn gweithio heb y setTimeout()
        // this.testun.next(rhybudd);
        setTimeout(() => this.testun.next(rhybudd), 0);
    }

    clirio(rhybuddId?: string) {
        this.testun.next(new Rhybudd({ rhybuddId }));
    }
}
